import { Auth } from 'aws-amplify';
import axios from 'axios';
import { APIConfig } from '../config';

const headers = {
  'Content-Type': 'application/json'
};

const axiosClient = axios.create({
  baseURL: APIConfig.apiUrl,
  timeout: 300000,
  headers,
});

axiosClient.interceptors.request.use(async (config) => {
  try {
    if (config.url.includes('/channel-partner/verify')
    || config.url.includes('/dealer/verify')
    || config.url.includes('/technician/otp')
    || config.url.includes('/link/verify-payment')
    ) {
      return config;
    }
    // Do something before request is sent
    const session = await Auth.currentSession();
    const token = session?.getAccessToken().getJwtToken();
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  } catch (err) {
    // Error while fetching token
    console.log('Error while fetching token', err);
    const statusCode = err.response.status;
    const { data } = err.response;
    const message = data.message || data;
    if (statusCode === 400 && (message.indexOf('Refresh Token has expired') > -1)) {
      localStorage.clear();
      window.location.href = '/login';
    }
  }
  return config;
});

axiosClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const statusCode = err.response.status;
    const { data } = err.response;
    const message = data.message || data;
    // When respose is unauthorized signout of the session and redirect to login
    if (statusCode === 403
      || (statusCode === 500 && (message.indexOf('Invalid value "undefined" for header "Authorization"') > -1))) {
      Auth.signOut();
      localStorage.clear();
      window.location.href = '/login';
    }
    throw err;
  }
);

export default axiosClient;
